module.exports = __webpack_public_path__ + "static/media/search-icon.f8fd06d9.svg";